require("../../../static/js/analytics/munchkin.js");
